import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEmpty = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 287,
	height: 175,
	viewBox: "0 0 287 175",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_530_6783)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M274.56 25.74C281.19 25.74 286.57 31.12 286.57 37.75C286.57 44.38 281.19 49.76 274.56 49.76H205.92C212.55 49.76 217.93 55.14 217.93 61.77C217.93 68.4 212.55 73.78 205.92 73.78H243.67C250.3 73.78 255.68 79.16 255.68 85.79C255.68 92.42 250.3 97.8 243.67 97.8H226.21C217.85 97.8 211.06 103.18 211.06 109.81C211.06 114.23 214.49 118.24 221.36 121.82C227.99 121.82 233.37 127.2 233.37 133.83C233.37 140.46 227.99 145.84 221.36 145.84H78.94C72.31 145.84 66.93 140.46 66.93 133.83C66.93 127.2 72.31 121.82 78.94 121.82H12.01C5.38 121.82 0 116.44 0 109.81C0 103.18 5.38 97.8 12.01 97.8H80.65C87.28 97.8 92.66 92.42 92.66 85.79C92.66 79.16 87.28 73.78 80.65 73.78H37.75C31.12 73.78 25.74 68.4 25.74 61.77C25.74 55.14 31.12 49.76 37.75 49.76H106.39C99.76 49.76 94.38 44.38 94.38 37.75C94.38 31.12 99.76 25.74 106.39 25.74H274.56ZM274.56 73.79C281.19 73.79 286.57 79.17 286.57 85.8C286.57 92.43 281.19 97.81 274.56 97.81C267.93 97.81 262.55 92.43 262.55 85.8C262.55 79.17 267.93 73.79 274.56 73.79Z",
				fill: "#E8E5FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M183.05 24.02L199.01 140.44L200.44 152.12C200.9 155.88 198.23 159.31 194.46 159.77L93.9699 172.11C90.2099 172.57 86.7799 169.9 86.3199 166.13L70.8499 40.13C70.6199 38.25 71.9599 36.54 73.8399 36.3H73.8799L82.2199 35.36",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M185.17 23.73C185.01 22.56 183.93 21.73 182.75 21.9C181.58 22.06 180.76 23.14 180.92 24.32L185.17 23.74V23.73ZM199.01 140.44L201.14 140.18V140.15L199.01 140.44ZM82.45 37.5C83.63 37.37 84.47 36.31 84.34 35.13C84.21 33.95 83.15 33.1 81.97 33.24L82.45 37.5ZM88.71 32.48C87.53 32.61 86.69 33.67 86.82 34.85C86.95 36.03 88.01 36.87 89.19 36.74L88.71 32.48ZM97.06 35.86C98.24 35.73 99.08 34.67 98.95 33.49C98.82 32.31 97.76 31.46 96.58 31.6L97.06 35.86ZM180.91 24.32L196.87 140.74L201.12 140.16L185.16 23.74L180.91 24.32ZM196.87 140.71L198.3 152.39L202.56 151.87L201.13 140.19L196.87 140.71ZM198.3 152.39C198.62 154.98 196.78 157.33 194.19 157.65L194.71 161.91C199.65 161.3 203.16 156.81 202.55 151.87L198.29 152.39H198.3ZM194.19 157.65L93.7 169.99L94.22 174.25L194.71 161.91L194.19 157.65ZM93.7 169.99C91.11 170.31 88.76 168.47 88.44 165.88L84.18 166.4C84.79 171.34 89.28 174.85 94.22 174.24L93.7 169.98V169.99ZM88.44 165.88L72.97 39.88L68.71 40.4L84.18 166.4L88.44 165.88ZM72.97 39.88C72.88 39.17 73.38 38.53 74.09 38.45L73.57 34.19C70.51 34.57 68.34 37.35 68.71 40.41L72.97 39.89V39.88ZM74.09 38.45H74.1L73.62 34.19C73.62 34.19 73.58 34.19 73.56 34.19L74.08 38.45H74.09ZM74.1 38.45L82.44 37.51L81.96 33.25L73.62 34.19L74.1 38.45ZM89.18 36.76L97.05 35.88L96.57 31.62L88.7 32.5L89.18 36.76Z",
				fill: "#8254FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M178.7 31.3501L193.15 136.86L194.45 147.45C194.87 150.86 192.48 153.96 189.11 154.37L99.1201 165.42C95.7501 165.83 92.6801 163.41 92.2601 159.99L78.2701 46.0901C78.0401 44.2101 79.3801 42.5001 81.2601 42.2701L92.3901 40.9001",
				fill: "#F8F7FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M104.54 6.85989C104.54 4.24989 106.65 2.13989 109.26 2.13989H187.44C188.69 2.13989 189.89 2.63989 190.78 3.51989L213.85 26.5699C214.73 27.4599 215.23 28.6599 215.23 29.9099V137.27C215.23 139.88 213.12 141.99 210.51 141.99H109.26C106.65 141.99 104.54 139.88 104.54 137.27V6.85989Z",
				fill: "white",
				stroke: "#8254FF",
				strokeWidth: 4.29
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M188.2 4.12012V24.0201C188.2 26.8601 190.5 29.1701 193.35 29.1701H206.96",
				stroke: "#8254FF",
				strokeWidth: 4.29,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M140 51.5232C140 51.5232 143.536 36 158.413 36C174.741 36 184.664 53.6122 175.499 65.3206C174.757 66.2619 169.078 71.4556 168.198 72.2482C162.161 77.6731 159.195 86.6154 159.22 95.533V100",
				stroke: "#8254FF",
				strokeWidth: 8,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M159.946 115.889C162.501 115.827 164.522 113.706 164.461 111.151C164.399 108.597 162.278 106.576 159.723 106.637C157.169 106.699 155.148 108.82 155.209 111.374C155.271 113.929 157.392 115.95 159.946 115.889Z",
				fill: "#8254FF"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_530_6783",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 286.57,
			height: 174.31,
			fill: "white"
		})
	}) })]
});
export default SvgEmpty;
